import type { SopParam } from '@erp/rpc';

export interface StudioParameterValues {
  values: Record<string, string>;
  missingRequired: string[];
}

/** The values a parameter form should OPEN with: every declared default, prefilled so the operator
 * sees what the run will actually use (and can edit it) instead of a blank box whose placeholder is
 * only the description. Parameters without a default start empty. */
export function initialParameterValues(
  parameters: SopParam[],
): Record<string, string> {
  const values: Record<string, string> = {};
  for (const parameter of parameters) {
    if (parameter.default != null && parameter.default !== '') {
      values[parameter.name] = parameter.default;
    }
  }
  return values;
}

/** Resolve the exact generation bag shown in the UI: an explicit edit wins, then the SOP default;
 * empty optional fields are omitted, while empty required fields block generation. */
export function resolveStudioParameterValues(
  parameters: SopParam[],
  edits: Record<string, string>,
): StudioParameterValues {
  const values: Record<string, string> = {};
  const missingRequired: string[] = [];
  for (const parameter of parameters) {
    const value = edits[parameter.name] ?? parameter.default ?? '';
    if (value.trim().length === 0) {
      if (parameter.required) missingRequired.push(parameter.name);
      continue;
    }
    values[parameter.name] = value;
  }
  return { values, missingRequired };
}
